export default __webpack_public_path__ + "static/media/menuIcon.1043b9b7.svg";